<template>
  <section>
    <v-btn style="position: absolute;right: 20px; top: 10px;" :title="$t('dashboard.refresh')" icon @click="fetchBookmarks">
      <v-icon x-small>
        fa-sync-alt
      </v-icon>
    </v-btn>
    <v-card-title>
      <v-text-field
        v-model="search"
        :label="$t('bookmarks.list.search')"
        append-icon="mdi-magnify"
        single-line
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="bookmarks_headers"
      :items="bookmarks_data"
      :items-per-page="10"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-dialog v-model="updateDialog" max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t("bookmarks.update_dialogue.title") }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="editedBookmark.url" :label="$t('bookmarks.list.url')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="editedBookmark.title" :label="$t('bookmarks.list.title')"></v-text-field>
                  </v-col>
                  <v-col cols="2" md="2">
                    <v-text-field v-model="editedBookmark.dt" :label="$t('bookmarks.list.dt')" readonly></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="updateDialog = false">
                {{ $t("bookmarks.update_dialogue.cancel") }}
              </v-btn>
              <v-btn color="blue darken-1" text @click="updateBookmark">
                {{ $t("bookmarks.update_dialogue.ok") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="deleteDialog" max-width="500px">
          <v-card>
            <v-card-title class="headline">{{ $t("bookmarks.delete_dialogue.title") }}</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedBookmark.url"
                      :label="$t('bookmarks.list.url')"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteDialog = false"
                >{{ $t("bookmarks.delete_dialogue.cancel") }}
              </v-btn>
              <v-btn color="blue darken-1" text @click="deleteBookmark()"
                >{{ $t("bookmarks.delete_dialogue.ok") }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.url="{ item }">
        <a :href="item.url" target="_blanc" :title="item.url">{{ item.host }}</a>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn :title="$t('bookmarks.list.edit')" text x-small @click="editBookmark(item)">
          <v-icon small>fas fa-edit</v-icon>
        </v-btn>
        <v-btn :title="$t('bookmarks.list.delete')" text x-small @click="deleteAskBookmark(item)">
          <v-icon small>fas fa-trash</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import {Types as TypesLoading} from "@/store/modules/loading";

export default {
  name: "Bookmarks",
  data: () => ({
    search: "",
    bookmarks_structure: {},
    bookmarks_data: [],
    bookmarks_headers: [],
    editedIndex: -1,
    editedBookmark: {
      url: "",
      previous_url: "",
      title: 0,
      dt: "",
    },
    updateDialog: false,
    deleteDialog: false,
  }),
  mounted() {
    this.bookmarks_headers = [
      {
        text: this.$t("bookmarks.list.url"),
        value: "url",
      },
      {
        text: this.$t("bookmarks.list.title"),
        value: "title",
      },
      {
        text: this.$t("bookmarks.list.dt"),
        value: "dt",
      },
      {
        text: this.$t("bookmarks.list.actions"),
        value: "actions",
        sortable: false,
      },
    ]
    this.fetchBookmarks()
  },
  methods: {
    editBookmark(bookmark) {
      this.editedIndex = this.bookmarks_data.indexOf(bookmark)
      this.editedBookmark = Object.assign({}, bookmark)
      this.editedBookmark.previous_url = bookmark.url
      this.updateDialog = true
    },
    deleteAskBookmark(bookmark) {
      this.editedIndex = this.bookmarks_data.indexOf(bookmark)
      this.editedBookmark = Object.assign({}, bookmark)
      this.deleteDialog = true
    },
    updateBookmark() {
      //-- bookmarks_structure with the content of bookmark
      if (this.editedBookmark.previous_url !== this.editedBookmark.url) {
        delete this.bookmarks_structure[this.editedBookmark.previous_url]
      }
      this.bookmarks_structure[this.editedBookmark.url] = {
        title: this.editedBookmark.title,
        dt: this.editedBookmark.dt,
      }
      this.$axios.post("office/me/users/bookmarks/replace/structure", {
        structure: this.bookmarks_structure,
      })
      this.formatData(this.bookmarks_structure)
      this.updateDialog = false
    },
    deleteBookmark() {
      delete this.bookmarks_structure[this.editedBookmark.url]
      this.$axios.post("office/me/users/bookmarks/replace/structure", {
        structure: this.bookmarks_structure,
      })
      this.formatData(this.bookmarks_structure)
      this.deleteDialog = false
    },
    fetchBookmarks() {
      this.$store.commit(TypesLoading.mutations.LOADING_YES)
      this.$axios.get("user/bookmark").then(response => {
        this.bookmarks_structure = response.data
        this.formatData(this.bookmarks_structure)
      }).finally(() => this.$store.commit(TypesLoading.mutations.LOADING_NO))
    },
    formatData(bookmarks) {
      this.bookmarks_data = []
      Object.entries(bookmarks).forEach(bm => {
        let objUrl = new URL(bm[0])
        this.bookmarks_data.push({
          host: objUrl.hostname,
          url: bm[0],
          dt: bm[1].dt,
          title: bm[1].title,
        })
      })
    },
  },
}
</script>
